export const useDocumentParagraphsStore = (documentId: string) => {
  const { revision } = useSubmittedDocumentStore(documentId);

  if (!revision) {
    throw new Error("Revision is not defined");
  }

  return useDocumentParagraphs(documentId, revision.id)();
};
